module.exports = __webpack_public_path__ + "static/media/jayz-reasonabledoubt.896b0719.jpg";